import { Button } from '@platform/ui'
import { createRoot } from 'react-dom/client'
import i18n from '@/plugins/i18n'

export const addPDFOpenButton = (wrapper: HTMLDivElement, url: string, clickHandler: (url: string) => void) => {
  const div = document.createElement('div')
  div.classList.add('button-area')
  wrapper.appendChild(div)

  const root = createRoot(div)
  root.render(
    <Button
      text={i18n.t('pdfViewer.open')}
      data-pdf-url={url}
      onClick={() => clickHandler(url)}
      data-pdf-handler-attached="1"
    />,
  )
}
